export default __webpack_public_path__ + "static/media/R6No1.d1ba2c11.mp3";